<template>
  <span v-bind:class="$mq">
    <AccountLink v-bind:account="account" /> ->
    <AccountLink v-bind:account="destination" />

    ({{balance | round | delim}} / {{amount | round | delim}} )
  </span>
</template>

<script>
import AccountLink from '../AccountLink.vue'
import config from '../../config'

export default {
  name : 'PaychanObj',
  components : {AccountLink},

  props : {
    obj : Object
  },

  computed : {
    account : function(){
      return this.obj["Account"];
    },

    destination : function(){
      return this.obj["Destination"];
    },

    balance : function(){
      return this.obj["Balance"] / config.DROPS_PER_XRP;
    },

    amount : function(){
      return this.obj["Amount"] / config.DROPS_PER_XRP;
    },
  },
}
</script>

<style scoped>
</style>
